import { render, staticRenderFns } from "./MenuContainer.vue?vue&type=template&id=94e5c46c&scoped=true"
import script from "./MenuContainer.vue?vue&type=script&lang=js"
export * from "./MenuContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e5c46c",
  null
  
)

export default component.exports